import type { QueryClient } from '@tanstack/react-query';
import type { ResultOf } from 'gql.tada';

import { gqlFetcher, graphql } from '#features/api';

export const landingStatsDoc = graphql(`
  query LandingStats {
    page {
      stats {
        playersCount
        postsCount
      }
    }
  }
`);

export type LandingStats = NonNullable<ResultOf<typeof landingStatsDoc>['page']['stats']>;

export const landingStatsQueryOptions = () => ({
  queryKey: ['landingStats'],
  staleTime: 60 * 60 * 1000,
  queryFn: async ({ client }: { client: QueryClient }) => {
    try {
      const data = await gqlFetcher(landingStatsDoc, {}, { silent: true });
      return data.page.stats ?? client.getQueryData<LandingStats>(['landingStats']) ?? null;
    } catch {
      // Optional social proof must not take the landing down during a rolling release
      // or an API outage. A successful snapshot stays in React Query's cache.
      return client.getQueryData<LandingStats>(['landingStats']) ?? null;
    }
  },
});
